import { Alert, Card, Col, Row, Segmented, Typography } from 'antd'
import Title from 'antd/es/typography/Title'
import { FC, useMemo, useState } from 'react'
import styled from 'styled-components'
import { groupMachinesByBrand } from '../../../../helpers/grouping/group-machines-by-brand'
import Machine from '../../../../types/api/machine'

const ALL_BRANDS = 'all'

const PickerRoot = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`

const MachineCard = styled(Card)`
    height: 100%;

    .ant-card-body {
        padding: 12px;
    }
`

interface MachinePickerProps {
    machines: Machine[]
    onSelect: (machine: Machine) => void
    title: string
    groupByBrand?: boolean
}

const MachinePicker: FC<MachinePickerProps> = ({
    machines,
    onSelect,
    title,
    groupByBrand = false,
}) => {
    const [selectedBrand, setSelectedBrand] = useState<string>(ALL_BRANDS)

    const brandOptions = useMemo(() => {
        if (!groupByBrand) {
            return []
        }
        const brands = Object.keys(groupMachinesByBrand(machines)).sort((a, b) =>
            a.localeCompare(b)
        )
        return [{ label: 'Все', value: ALL_BRANDS }, ...brands.map(brand => ({ label: brand, value: brand }))]
    }, [groupByBrand, machines])

    const visibleMachines = useMemo(() => {
        if (!groupByBrand || selectedBrand === ALL_BRANDS) {
            return machines
        }
        return machines.filter(machine => (machine.machine_brand?.name || 'Unknown') === selectedBrand)
    }, [groupByBrand, machines, selectedBrand])

    return (
        <PickerRoot>
            <Title level={2}>{title}</Title>
            <Alert
                type='info'
                showIcon
                message='Указать другой станок можно, выполнив вход в систему повторно'
            />
            {groupByBrand && brandOptions.length > 1 && (
                <Segmented
                    options={brandOptions}
                    value={selectedBrand}
                    onChange={value => setSelectedBrand(String(value))}
                    block
                />
            )}
            <Row gutter={[12, 12]}>
                {visibleMachines.map(machine => (
                    <Col xs={12} sm={8} md={6} key={machine.documentId}>
                        <MachineCard size='small' hoverable onClick={() => onSelect(machine)}>
                            <Typography.Text strong ellipsis>
                                {machine.name}
                            </Typography.Text>
                        </MachineCard>
                    </Col>
                ))}
            </Row>
        </PickerRoot>
    )
}

export default MachinePicker
